"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var abstract_1 = require("./abstract");
var getFileId = function () {
    // @ts-ignore
    var url = window.urlFileId;
    return url || '';
};
var getOfficeType = function () {
    var type;
    // weboffice
    // @ts-ignore
    switch (window.officeType) {
        case 'o':
            type = abstract_1.OfficeType.otl;
            break;
        case 'k':
            type = abstract_1.OfficeType.ksheet;
            break;
        case 'p':
            type = abstract_1.OfficeType.wpp;
            break;
        case 's':
            type = abstract_1.OfficeType.et;
            break;
        case 'w':
            type = abstract_1.OfficeType.wps;
            break;
        case 'd':
            type = abstract_1.OfficeType.db;
            break;
        case 'f':
            type = abstract_1.OfficeType.pdf;
            break;
        case 'b':
            type = abstract_1.OfficeType.kw;
            break;
        case 'i':
            type = abstract_1.OfficeType.img;
            break;
    }
    return type || abstract_1.OfficeType.unknown;
};
var getDocumentInfo = function () { return ({}); };
var addDocumentActivedListener = function () {
    // do nothing
};
var removeDocumentActivedListener = function () {
    // do nothing
};
var addDocBecomeCloudDocListener = function () {
    // do nothing
};
var removeDocBecomeCloudDocListener = function () {
    // do nothing
};
var file = {
    getFileId: getFileId,
    getOfficeType: getOfficeType,
    getDocumentInfo: getDocumentInfo,
    addDocumentActivedListener: addDocumentActivedListener,
    removeDocumentActivedListener: removeDocumentActivedListener,
    addDocBecomeCloudDocListener: addDocBecomeCloudDocListener,
    removeDocBecomeCloudDocListener: removeDocBecomeCloudDocListener
};
exports.default = file;
